import { useState, useContext, useEffect } from "react";
import { FaEdit, FaTrashAlt, FaCalendarAlt, FaClipboardList, FaCogs, FaChartLine, FaPlusCircle } from "react-icons/fa";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import Button from "components/ui/controls/button/button";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import { AppContext } from "components/app/RemExprertProvider";
import Dialogs from "components/ui/dialogs/dialogs";
import { createStyledButton } from "components/ui/controls/button/button-styles";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { RemExpertResultatSalarie } from "components/app/Api/ResultatRemExpertSalarieProvider";
import OptiRemPage from "./optiRem";
import "components/app/Extranet/ListeAudits.css";
import SimulationRetraite from "pages/audit retraite/resultat/simulationRetraite";

const SimulationPage = (props) => {
  const context = useContext(AppContext);
  const [showOptiRemFullScreen, setShowOptiRemFullScreen] = useState(false);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const ResultatSalarie = useContext(RemExpertResultatSalarie);
  const Periode = context.state["PeriodeActuelle"][0];
  const PeriodeConjoint = context.state["PeriodeActuelleConjoint"][0];

  // Notifier le parent de l'état du menu
  useEffect(() => {
    if (props?.onMenuVisibilityChange) {
      props.onMenuVisibilityChange(!showOptiRemFullScreen);
    }
  }, [showOptiRemFullScreen, props]);

  useEffect(() => {
    if (Periode !== undefined) {
      if (Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel") {
        ResultatTNS.GetResultRemExpert(context.state, "").then(() => {});
      } else {
        ResultatSalarie.GetResultRemExpert(context.state, "").then(() => {});
      }

      if (context.state.InclureConjoint === true && Periode?.StatutConjoint !== "Aucun") {
        if (Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel") {
          ResultatTNS.GetResultRemExpert(context.state, "ConjointAssocie").then(() => {});
        } else {
          ResultatSalarie.GetResultRemExpert(context.state, "ConjointAssocie").then(() => {});
        }
      }
    }
    if (PeriodeConjoint !== undefined) {
      if (PeriodeConjoint?.Statut === "TNS Article 62" || PeriodeConjoint?.Statut === "TNS individuel") {
        ResultatTNS.GetResultRemExpert(context.state, "Conjoint").then(() => {});
      } else {
        ResultatSalarie.GetResultRemExpert(context.state, "Conjoint").then(() => {});
      }
    }

    context.handleOpenRemiseDonneeOptirem("", ResultatTNS, ResultatSalarie).then(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // useEffect(() => {
  //   context.GetDateDepartRetraite("", context.state);
  //   if (context.state.CarriereConjoint.length > 0) {
  //     context.GetDateDepartRetraite("Conjoint", context.state);
  //   }

  // }, []);
  return (
    <>
      {showOptiRemFullScreen ? (
        <OptiRemPage
          ClientConjoint={""}
          visible={showOptiRemFullScreen}
          onMenuVisibilityChange={props?.onMenuVisibilityChange}
          onClose={() => {
            setShowOptiRemFullScreen(false);
          }}
        />
      ) : (
        <>
          <Column fill>
            <Row>
              <Column fill>
                <CardBox bpad>
                  <Column fill>
                    <Row>
                      <div className="page-title-container">
                        <div className="page-title-content">
                          <div className="page-title-icon">
                            <FaChartLine />
                          </div>
                          <div className="page-title-text">
                            <h1>Simulations d'optimisation</h1>
                            <p className="page-title-subtitle">Gestionnaire de scénarios d'optimisation</p>
                          </div>
                        </div>
                      </div>
                    </Row>
                    <Row>
                      <Column fill>
                        <CardBoxHeader icon={<FaPlusCircle />}>Nouvelle simulation</CardBoxHeader>
                      </Column>
                    </Row>

                    <Row center>
                      <Column fill>
                        <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap", marginBottom: "20px" }}>
                          <ActionButton
                            onClick={() => {
                              context.handleResetOptimisation();
                              context.handleOpenRemiseDonneeOptirem("", ResultatTNS, ResultatSalarie);
                              setShowOptiRemFullScreen(true);
                            }}
                            icon={FaCogs}
                            title="Gestionnaire de scénarios"
                            subtitle="Optimisation complète"
                            colors={{
                              primary: "#11998e",
                              secondary: "#0d7377",
                              shadow: "rgba(17, 153, 142, 0.4)",
                              shadowHover: "rgba(17, 153, 142, 0.6)",
                            }}
                            decorativeIcon={{ type: "scenarios" }}
                            style={{ minWidth: "280px" }}
                          />
                        </div>
                      </Column>
                    </Row>
                    <Row>
                      <Column scroll fill>
                        <div className="studies-scroll">
                          <Row style={{ marginBottom: "16px" }}>
                            <CardBoxHeader icon={<FaClipboardList />}>Simulations enregistrées ({context.state.ListeOptimisation?.length || 0})</CardBoxHeader>
                          </Row>
                          {context.state.ListeOptimisation?.length === 0 ? (
                            <div className="studies-empty">
                              <FaClipboardList className="studies-empty-icon" />
                              <p className="studies-empty-text">Aucune simulation trouvée</p>
                            </div>
                          ) : (
                            context.state.ListeOptimisation?.map((Infos, Index) => {
                              var date = new Date(Infos.DateAdd);
                              var year = date.getFullYear();
                              var month = (1 + date.getMonth()).toString();
                              month = month.length > 1 ? month : "0" + month;
                              var day = date.getDate().toString();
                              day = day.length > 1 ? day : "0" + day;
                              date = day + "/" + month + "/" + year;

                              return (
                                <div className="study-card" key={"SIMULATION" + Index}>
                                  <div className="study-card-main">
                                    <div className="study-card-info">
                                      <div className="study-card-avatar">{Infos.LibelleOptimisation?.[0] || "S"}</div>
                                      <div className="study-card-details">
                                        <div className="study-card-row">
                                          <h4 className="study-card-title">{Infos.LibelleOptimisation}</h4>
                                        </div>
                                        <div className="study-card-type">Gestionnaire de scénarios</div>
                                        <div className="study-card-date">
                                          <FaCalendarAlt style={{ fontSize: "11px", color: "#666" }} />
                                          <span>Créé le {date}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="study-card-actions">
                                      <Button
                                        onClick={() => {
                                          context.handleAccesOptimisation(Infos.IdOptimisation, ResultatTNS);
                                          setShowOptiRemFullScreen(true);
                                        }}
                                        icon
                                        {...createStyledButton("card-action", "cardEdit")}
                                      >
                                        <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          Dialogs.confirm("Vous êtes sur le point de supprimer la simulation.\nVoulez-vous continuer ?", "Suppression d'une simulation", () => {
                                            context.handleDeleteOptimisation(Infos.IdOptimisation);
                                          });
                                        }}
                                        icon
                                        {...createStyledButton("card-action", "delete")}
                                      >
                                        <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </Column>
                    </Row>
                      <Row>
                      <Column fill>
                        <CardBoxHeader icon={<FaPlusCircle />}>Simulations retraite {context.state.Prenom}</CardBoxHeader>
                      </Column>
                    </Row>
                    <Row>
                      <Column fill>
                        <SimulationRetraite ClientConjoint="" openInModal />
                      </Column>
                    </Row>
                    {context.state.InclureConjoint === true && (
                      <>
                        <Row>
                          <Column fill>
                            <CardBoxHeader icon={<FaPlusCircle />}>Simulations retraite {context.state.PrenomConjoint}</CardBoxHeader>
                          </Column>
                        </Row>
                        <Row>
                          <Column fill>
                            <SimulationRetraite ClientConjoint="Conjoint" openInModal />
                          </Column>
                        </Row>
                      </>
                    )}
                  </Column>
                </CardBox>
              </Column>
            </Row>
          </Column>

        </>
      )}
    </>
  );
};

export default SimulationPage;
